export const CHECK_TYPE_LABEL: Record<string, string> = {
  CASH_APP_UPLOADED_UP_TO_FY_END: "Cash app uploaded up to FY end date",
  BANK_RECONCILIATION_DONE: "Bank Reconciliation Done",
  ALL_COLLECTIONS_CLEARED: "All collections cleared (A/R)",
  ALL_VENDOR_INVOICES_UPLOADED: "All vendor invoices uploaded (A/P)",
  ALL_VENDOR_PAYMENTS_CLEARED: "All vendor payments cleared",
  AR_AP_OUTSTANDING_REVIEWED: "A/R & A/P outstanding reviewed",
  GL_REVIEW_DONE_INCLUDING_OPEN_ITEMS:"GL Review done including Open Items",
  RESERVES_REVIEWED: "Reserves Reviewed",
  ALL_COLLECTIONS_CLEARED_AR: "All collections cleared (A/R)",
  ALL_VENDOR_INVOICES_UPLOADED_AP: "All vendor invoices uploaded (A/P)",
};